'use strict';

gsap.registerPlugin(ScrollTrigger);

//SCRIPT FOR EYES FOLLOWING MOUSE MOVEMENT - AIDE TUTORIAL + PROFESSEUR
const eyes = document.querySelectorAll('.header-eye-container img');

if (eyes) {

document.addEventListener('mousemove', (e) => {


    const mouseX = e.clientX;
    const mouseY = e.clientY;

   
    eyes.forEach((eye) => {
        eye.style.left = `${mouseX / 20}px`;
        eye.style.bottom = `${-mouseY / 11}px`;
})
});

function angle(cx, cy, ex, ey) {

    const dy = ey - cy;
    const dx = ex - cx;
    const rad = Math.atan2(dy, dx); // range (-PI, PI)
    const deg = rad * 180 / Math.PI; // rads to degs
    return deg; // range (-180, 180)

}
}

//SCRIPT MENU ANIMATION

const btn = document.querySelector(".nav-action-btn");
const menuElements = document.querySelectorAll(".menu__el");

let toggled = false;

if(btn)
btn.addEventListener("click", () => {
  toggled = !toggled;
  menuElements.forEach((el, index) => {
    setTimeout(() => {
      if (toggled) {
        el.classList.add("show");
      } else {
        el.classList.remove("show");
      }
    }, index * 150);
  });
});

//SCROLL TRIGGER ANIMATION IMAGES POP-UP

gsap.utils.toArray('.img-pop').forEach((pop) => {
  const startValue = pop.dataset.start || "top 80%"; // fallback si absent

  gsap.fromTo(pop,
    {
      opacity: 0,
      scale: 0.5
    },
    {
      opacity: 1,
      scale: 1,
      duration: 1,
      ease: "back.out(1.7)",
      scrollTrigger: {
        trigger: pop,
        start: startValue,
        end: "top 60%",
        scrub: true,
        toggleActions: "play reverse play reverse"
      }
    }
  );
});

//GO BACK BUTTON
document.addEventListener("DOMContentLoaded", () => {
  const backIcon = document.querySelector(".back-icon");

  if(backIcon){
    backIcon.addEventListener("click", () => {
    window.history.back();
    });
  }
});

//SCROLL TRIGGER ANIMATION SECTION

gsap.utils.toArray(".section-case-study, .separator").forEach(element => {
  gsap.to(element, {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });
});